import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, MenuProps, Space } from 'antd';
import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';

const InfoSystem: React.FC = () => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('access_token');
    navigate("/auth/login");
  }

  const menuItems: MenuProps['items'] = [
    {
      key: 'logout',
      label: 'Đăng xuất',
      icon: <LogoutOutlined />,
      onClick: logout,
    },
  ];

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']}>
      <a onClick={(e) => e.preventDefault()} style={{ cursor: 'pointer' }}>
        <Space>
          <Avatar size={38} icon={<UserOutlined />} style={{ background: '#F7E3E9', color: '#D6708D' }} />
        </Space>
      </a>
    </Dropdown>
  );
};

export default memo(InfoSystem);